import type { DependencyFilterVersionType } from '../../shared/model-typings';

/**
 * Quality rules (specifically, `whitelisted_dependency` || `blacklisted_dependency`)
 * allow users to allow/block specific packages. Often these are specific versions,
 * however they are also able to allow/block entire ranges. This function helps
 * format this into something which is more human-readable.
 *
 * @param {DependencyFilterVersionType} versionFilterType - Type of version filter.
 * @param {string} startVersion - Start of the version range (or pinned version if not a range.)
 * @param {string} [endVersion] - End of the version range (optional).
 * @returns {string} Human-readable version range string.
 */
export const getQualityFilterVersionString = (
  versionFilterType: DependencyFilterVersionType,
  startVersion: string,
  endVersion?: string,
): string => {
  switch (versionFilterType) {
    case 'ALL':
      return '(ALL VERSIONS)';
    case 'EQUAL':
      return startVersion;
    case 'GREATER':
      return `> ${startVersion}`;
    case 'LESS':
      return `< ${endVersion}`;
    case 'RANGE':
      return `${startVersion} - ${endVersion}`;
    default:
      //  Default to simply the startVersion if we don't know what to use.
      return startVersion || 'Unknown';
  }
};
